import { format } from 'date-fns';
import fileToBase64 from '../../../procedures/file-to-base64';
import httpBuildQuery from '../../../procedures/http-build-query';
import iterateObject from '../../../procedures/iterate-object';
import modelId from '../../../procedures/model-id';
import column from '../../abstract/column';
import form from '../../abstract/form';
import vars from '../../abstract/vars';
import agreementApi from '../agreement/api';
import actions from './actions';
import api, { modelName } from './api';

const filterAgreementOriginal = ($route) => JSON.parse($route?.query?.f || '{}')?.agreement_original;

const agreementList = async (query, { $route }) => {
  const additionalQuery = {};
  const agreementOriginal = filterAgreementOriginal($route);

  if (agreementOriginal) {
    additionalQuery._crm_by_agreements = [agreementOriginal];
  }

  const id = $route?.params?.id;

  if (id) {
    additionalQuery._crm_by_agreement_files = [id];
  }

  return await agreementApi.list({
    ...query,
    f: {
      ...(query?.f || {}),
      ...additionalQuery,
    },
  });
};

export const signStatusOptions = {
  none: {
    label: 'Nie podpisano',
    value: 0,
    color: 'danger',
  },
  onlyMe: {
    label: 'Podpisano przeze mnie',
    value: 1,
    color: 'warning',
  },
  onlyClient: {
    label: 'Podpisano przez kontrahenta',
    value: 2,
    color: 'warning',
  },
  bothSign: {
    label: 'Podpisano przez obie strony',
    value: 3,
    color: 'success',
  },
};

const signedAtFormat = 'yyyy-MM-dd';

export default {
  actions,
  topRightActions: {
    create: {
      label: 'Dodaj dokument',
      icon: 'icon-plus',
      handle: async ({ $route, $router }) => {
        const { f } = $route.query;
        const query = f ? httpBuildQuery({ f }) : '';
        await $router.push(`/crm-agreement-files/add${ query }`);
      },
    },
  },
  api,
  modelName,
  sidebarData: {
    id: column({
      label: 'Identyfikator',
      size: 100
    }),
  },
  columns: {
    agreement: column({
      label: 'Umowa',
      form: form({
        required: true,
        reverseTransform: ({ value }) => modelId(value),
      }),
      format: (item) => `Umowa nr ${ item.agreement.number.number }`,
      model: (models) => ({
        ...models.crm.agreement,
        api: {
          ...models.crm.agreement.api,
          list: async (query, { $route }) => await agreementList(query, { $route }),
        },
      }),
    }),
    agreement_original: column({
      label: 'Umowa',
      grid: false,
      sidebar: false,
    }),
    editor: column({
      label: 'Dodano przez',
      component: 'value-editor',
    }),
    created_at: column({
      label: 'Data dodania',
    }),
    sign_status: column({
      label: 'Status podpisu',
      component: 'value-status',
      form: form({
        required: true,
      }),
      options: signStatusOptions,
    }),
    signed_at: column({
      label: 'Data podpisu',
      form: form({
        required: true,
        render: ({ data: { sign_status } }) => sign_status,
        transformIf: ({ data: { sign_status }, value }) => sign_status && value,
        transform: ({ value }) => new Date(value),
        reverseTransform: ({ value }) => format(value, signedAtFormat),
      }),
      dateFormat: signedAtFormat,
    }),
    sent_at: column({
      label: 'Data wysłania',
      grid: false,
    }),
    sent_to: column({
      label: 'Wysłano do',
      grid: false,
    }),
    content: column({
      label: 'Dokument',
      grid: false,
      sidebar: false,
      form: form({
        required: true,
        component: 'upload',
        show: ({ data }) => !data.id,
        render: ({ item: { id } }) => !id,
        transformIf: ({ item: { id }, value }) => !id && value,
        reverseTransform: async ({ value }) => fileToBase64(value),
      }),
    }),
  },
  vars: vars({
    softDelete: {
      title: 'Usunięcie dokumentu',
      text: ({ agreement }) => `Czy napewno chcesz usunąć dokument dla umowy nr ${ agreement.number.number }?`,
      successText: 'Dokument został usunięty.',
    },
    noItemsText: 'Brak dokumentów',
    sidebarLabel: 'Podgląd dokumentu',
    mainTabLabel: 'Dokument',
    initItem: async ({ $route }) => {
      const fetchAgreement = async () => {
        const agreementOriginal = filterAgreementOriginal($route);

        if (!agreementOriginal) {
          return null;
        }

        const { data } = await agreementList({}, { $route });
        const agreement = iterateObject(data).find(({ original }) => original === agreementOriginal);

        return modelId(agreement);
      };

      return {
        agreement: await fetchAgreement(),
        sign_status: signStatusOptions.bothSign.value,
        signed_at: `${ format(new Date(), signedAtFormat) } 00:00:00`,
      };
    },
    onSuccessSave: async ({ $router, data: { agreement_original } }) => {
      await $router.push({
        path: '/crm-agreement-files',
        query: { f: JSON.stringify({ agreement_original }) },
      });
    },
  }),
};
